/**
 * 打版触发页 —— 从 JobList 顶部 Tab 提为一级路由 (/schedule/release-triggers)。
 *
 * docs/platform-refactor-v1.md §1.1：计划任务从 JobList Tab 提为一级
 *
 * 实现细节：内容组件 ReleaseTriggerTab 沿用原位置的实现，
 * 本文件只提供页面标题 + padding 外壳。权限点 release_trigger_rule:manage
 * 由 ReleaseTriggerTab 内部消费，此处不重复守卫。
 */
import { Typography } from 'antd';
import ReleaseTriggerTab from '@/pages/JobList/ReleaseTriggerTab';

const { Title, Paragraph } = Typography;

export default function ReleaseTriggersPage() {
  return (
    <div style={{ padding: '24px 32px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>打版触发</Title>
        <Paragraph type="secondary" style={{ marginTop: 4, marginBottom: 0 }}>
          Kafka 打版事件按规则自动触发对应 Job；下方展示最近的打版事件与匹配结果。
        </Paragraph>
      </div>
      <ReleaseTriggerTab />
    </div>
  );
}
